// extracted by mini-css-extract-plugin
export default {"label":"InputBox_label__orH8V","textarea":"InputBox_textarea__Glv7j","input":"InputBox_input__xF4Xf"};